import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TimeFromNow from '../../../common/TimeFromNow';

const DocketEntriesTableHeader = ({ sortDockets, lastUpdated, lastUpdatedTitle, updateClick, pastEntriesClick }) => (
  <thead>
    <tr>
      <th style={{ width: '55px', whiteSpace: 'nowrap' }}>
        <div className="item" onClick={sortDockets.bind(null, 'date_filed')}>
          Date Filed
        </div>
      </th>
      <th style={{ width: '55px', textAlign: 'center' }}>#</th>
      <th style={{ width: '110px', textAlign: 'center' }}>
        <div className="item" onClick={sortDockets.bind(null, 'docket_text')}>
          Docket text
        </div>
      </th>
      <th id="docket_update_ctrl">
        <span className="ir-search-refresh-date" title={moment(lastUpdated).format('MMM D YYYY h:mm a')}>
          Last updated &nbsp;
          <TimeFromNow dateTime={lastUpdated} />
        </span>
        <div className="ui small secondary menu">
          <div className="item">
            <div id="update-from-pacer-link" title={lastUpdatedTitle} onClick={updateClick}>
              <img src="/sites/all/themes/inforuptcy/icons/icon-update.png" height="23" width="23" />
              Update
            </div>
          </div>
          <div className="item">
            <div title="Show/Hide Docket Import Form" onClick={pastEntriesClick}>
              <img src="/sites/all/themes/inforuptcy/icons/icon-past-entries.png" height="23" width="23" />
              Past Entries
            </div>
          </div>
        </div>
      </th>
    </tr>
  </thead>
);

DocketEntriesTableHeader.defaultProps = {
  lastUpdated: '',
  lastUpdatedTitle: '',
};

DocketEntriesTableHeader.propTypes = {
  sortDockets: PropTypes.func.isRequired,
  lastUpdated: PropTypes.string,
  lastUpdatedTitle: PropTypes.string,
  updateClick: PropTypes.func.isRequired,
  pastEntriesClick: PropTypes.func.isRequired,
};

export default DocketEntriesTableHeader;



// WEBPACK FOOTER //
// ./src/components/case/docket/docketEntries/DocketEntriesTableHeader.jsx